import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const TestFirebase = () => {
  const { currentUser, hasRole } = useAuth();
  const [results, setResults] = useState('');
  const [loading, setLoading] = useState(false);

  const isAdmin = hasRole('admin');

  const testFirebaseConnection = async () => {
    setLoading(true);
    setResults('Testing Firebase connection...\n\n');
    
    try {
      // Test 1: Check authentication
      setResults(prev => prev + `✅ Authentication: ${currentUser ? 'Logged in as ' + currentUser.email : 'Not logged in'}\n`);
      setResults(prev => prev + `✅ User Role: ${hasRole('admin') ? 'Admin' : 'Regular user'}\n\n`);

      // Test 2: Try to read groups collection
      setResults(prev => prev + '📋 Testing groups collection access...\n');
      const groupsRef = collection(db, 'groups');
      const groupsSnapshot = await getDocs(groupsRef);
      
      setResults(prev => prev + `✅ Groups collection: Found ${groupsSnapshot.size} documents\n`);
      
      // Test 3: List all group IDs and names
      setResults(prev => prev + '\n📋 Groups found:\n');
      groupsSnapshot.forEach((doc) => {
        const data = doc.data();
        setResults(prev => prev + `  - ID: "${doc.id}" | Name: "${data.name}" | Members: ${data.memberCount || 0}\n`);
      });

      // Test 4: Try to read specific group
      setResults(prev => prev + '\n📋 Testing specific group access (ID: "1")...\n');
      const group1Ref = doc(db, 'groups', '1');
      const group1Snapshot = await getDoc(group1Ref);
      
      if (group1Snapshot.exists()) {
        const group1Data = group1Snapshot.data();
        setResults(prev => prev + `✅ Group 1: "${group1Data.name}" with ${group1Data.memberCount || 0} members\n`);
      } else {
        setResults(prev => prev + `❌ Group 1: Document does not exist\n`);
      }

      // Test 5: Try to read group posts
      setResults(prev => prev + '\n📋 Testing group posts collection...\n');
      const postsRef = collection(db, 'groupPosts');
      const postsSnapshot = await getDocs(postsRef);
      
      setResults(prev => prev + `✅ Group posts: Found ${postsSnapshot.size} documents\n`);
      
      setResults(prev => prev + '\n🎉 All tests completed successfully!');
      
    } catch (error) {
      setResults(prev => prev + `\n❌ Error: ${error.message}\n`);
      setResults(prev => prev + `❌ Error code: ${error.code}\n`);
      console.error('Firebase test error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isAdmin) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900">Access Denied</h2>
          <p className="text-gray-600 mt-2">You don't have permission to access this debug tool.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Firebase Connection Test</h1>
        
        <button
          onClick={testFirebaseConnection}
          disabled={loading}
          className="mb-6 bg-apn-blue text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? 'Testing...' : 'Test Firebase Connection'}
        </button>

        {results && (
          <div className="bg-gray-50 border border-gray-200 rounded-md p-4">
            <h3 className="text-lg font-medium mb-2">Test Results:</h3>
            <pre className="text-sm text-gray-700 whitespace-pre-wrap font-mono">
              {results}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default TestFirebase;
